import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Método para obtener SGA completo de un producto químico.
 *
 * @param {*} param0
 */
export async function getSgaCompleto({commit, state, rootState}, id) {

  var idioma = state.idioma.seleccionado;
  var version = state.version;

  commit('dashboard/load', true, {root: true});

  await $http.get(`adm_productos/sga/completo/${id}/${idioma}/${version}`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setSgaCompleto', response.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message + '<br> ' + error.errors,
        showConfirmButton: true,
        timer: 5000
      });
    });
}

/**
 * Método para obtener las listas paramétricas de la clasificación de SGA
 *
 * @export
 * @param {*} { commit, state}
 */
export async function getClasificacionSGAListas({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http.get('controles/20')
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setClasificacionSGAListas', response.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}
